import { render, staticRenderFns } from "./notifications-list-page.vue?vue&type=template&id=0d7d5edb&"
import script from "./notifications-list-page.vue?vue&type=script&lang=js&"
export * from "./notifications-list-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports